export default {
  companyDemoMetadata: {
    title: 'Demo access to psychological tests',
    demo: 'Demonstration of personal test',
    description:
      'The page contains trial versions of tests with example reports in several views.<br />If you are interested in one of them, contact our managers or technical support.',
    note: 'Note: The sample reports are independent of the answers in the demo test, the reports at the end of the survey are always the same.',
    testExampleButton: 'Test example',
    testsTitle: {
      critical: 'Critical thinking',
      burnout: 'Burnout',
      frontStaff: 'FrontStaff',
      leadFive: 'Leadership Five Competencies',
      personalFactor: '11 personality factors (11ЛФ)',
      bigFive: 'Big Five Competencies',
      safetyStart: 'SafetyStart',
      leaderCase: 'LeaderCase',
      deMetrics: 'DeMetrics',
    },
    testsDescription: {
      critical: 'Express assessment of the ability to critically analyze information',
      burnout: 'Express assessment of professional burnout',
      frontStaff:
        'Express test of basic competencies and intellectual potential for those who work with people',
      leadFive:
        'Express assessment of the competencies of leaders: project managers, managers, entrepreneurs, anti-crisis managers',
      personalFactor: 'Express test of sales potential',
      bigFive: 'Express assessment of the competencies of employees of mass specialties',
      safetyStart:
        'Express test for selecting and assessing employees at enterprises with a high level of danger',
      leaderCase: 'Express case test of leadership potential',
      deMetrics: 'Express assessment of ten significant factors of motivation and job satisfaction',
    },
  },
};
